export default __webpack_public_path__ + "static/media/progress-background.dd23751b.png";